module.exports = __webpack_public_path__ + "static/indexHeader-11dcb9780535286d86956307fa7286ac.jpg";